import * as N from "react";
import { useState as s, useCallback as a, useLayoutEffect as p, useEffect as L, useRef as w, useReducer as P, useMemo as A } from "react";
import { canUseDOM as M } from "../../ariakit-utils/esm/dom.js";
import { applyState as U } from "../../ariakit-utils/esm/misc.js";
import { setRef as y } from "./misc.js";
const R = N.useId, l = N.useInsertionEffect, m = M ? p : L;
function f(t) {
  const e = w(t);
  return m(() => {
    e.current = t;
  }), e;
}
function O(t) {
  const [e, n] = s(t);
  return t !== e && n(t), e;
}
function B(t) {
  const e = w(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return l ? l(() => {
    e.current = t;
  }) : e.current = t, a(function() {
    var u;
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return (u = e.current) == null ? void 0 : u.call(e, ...r);
  }, []);
}
function C() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return A(() => {
    if (e.some(Boolean))
      return (r) => {
        e.forEach((o) => {
          y(o, r);
        });
      };
  }, e);
}
function W(t) {
  if (R) {
    const r = R();
    return t || r;
  }
  const [e, n] = s(t);
  return m(() => {
    if (t || e) return;
    const r = Math.random().toString(36).substr(2, 6);
    n(`id-${r}`);
  }, [t, e]), t || e;
}
function X(t, e) {
  const [n, r] = s(() => g(e));
  return m(() => {
    var o;
    r(((o = t == null ? void 0 : t.current) == null ? void 0 : o.tagName.toLowerCase()) || g(e));
  }, [t, e]), n;
}
function g(t) {
  if (typeof t == "string")
    return t;
}
function $(t, e, n) {
  const [r, o] = s(t), u = e !== void 0 ? e : r, v = f(e), T = f(n), S = f(u), d = a((i) => {
    const c = T.current;
    if (c)
      if (h(c))
        c(i);
      else {
        const E = U(i, S.current);
        S.current = E, c(E);
      }
    v.current === void 0 && o(i);
  }, []);
  return F(d), [u, d];
}
const x = Symbol("setNextState");
function h(t) {
  return t[x] === !0;
}
function F(t) {
  h(t) || Object.defineProperty(t, x, {
    value: !0
  });
}
function q() {
  return P(() => [], []);
}
function z(t) {
  return B(typeof t == "function" ? t : () => t);
}
function G(t, e, n) {
  n === void 0 && (n = []);
  const r = a((o) => (t.wrapElement && (o = t.wrapElement(o)), e(o)), [...n, t.wrapElement]);
  return {
    ...t,
    wrapElement: r
  };
}
function H(t, e) {
  t === void 0 && (t = !1);
  const [n, r] = s(null);
  return {
    portalRef: C(r, e),
    portalNode: n,
    domReady: !t || n
  };
}
export {
  z as useBooleanEvent,
  $ as useControlledState,
  B as useEvent,
  q as useForceUpdate,
  C as useForkRef,
  W as useId,
  f as useLiveRef,
  H as usePortalRef,
  O as usePreviousValue,
  m as useSafeLayoutEffect,
  X as useTagName,
  G as useWrapElement
};
//# sourceMappingURL=hooks.js.map
